import React from 'react'
import '../assets/scss/main.scss'
import Header from '../components/Header'
import Menu from '../components/Menu'
import Footer from '../components/Footer'


class Template extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            isMenuVisible: false,
            loading: 'is-loading',
            activeProject: null,
        }
        this.handleToggleMenu = this.handleToggleMenu.bind(this)
        this.setActiveProject = this.setActiveProject.bind(this)
    }

    componentDidMount () {
        this.timeoutId = setTimeout(() => {
            this.setState({loading: ''});
        }, 100);
    }

    componentWillUnmount () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    handleToggleMenu() {
        this.setState({
            isMenuVisible: !this.state.isMenuVisible
        })
    }

    setActiveProject(idx) {
        this.setState({
            activeProject: idx
        })
    }

    render() {
        const { children } = this.props
        const handleClick = this.setActiveProject

        return (
            <div className={`body ${this.state.loading} ${this.state.isMenuVisible ? 'is-menu-visible' : ''}`}>
                <div id="wrapper">
                    <Header onToggleMenu={this.handleToggleMenu} />
                    {children({...this.props, handleClick, ...this.state})}
                    {/* <Contact /> */}
                    <Footer />
                </div>
                <Menu onToggleMenu={this.handleToggleMenu} />
            </div>
        )
    }
}

Template.propTypes = {
    children: React.PropTypes.func
}

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.js